<div *ngIf="isLoading" class="overlay"></div>
<div *ngIf="isLoading" class="loader"></div>
<div class="example-inner">
  <div class="container">
    <div class="header">
        <button mat-raised-button 
              color="primary" 
              class="dashboard-button" 
              routerLink="/sales/generaldash">
        <mat-icon>dashboard</mat-icon>
        <span>Sales Dashboard</span>
        </button>
        <h1 class="page-title" >Employee TimeSheets</h1>
    </div>
  <kendo-tabstrip>
    <kendo-tabstrip-tab title="Employees TimeSheet" [selected]="true">
      <ng-template kendoTabContent>
        <div style="background-color: lightcyan;">
          <span><strong>TimeSheet Total</strong></span>
          <br/>
          <form [formGroup]="dateForm">
            Date From:<input  name="getDateFrom" matInput formControlName="getDateFrom" /> <span><strong>&nbsp; (DD/MM/YYYY) &nbsp;</strong></span>
            Date To:<input  name="getDateTo" matInput formControlName="getDateTo" /> <span><strong>&nbsp; (DD/MM/YYYY) &nbsp;</strong></span>
            <button style="float: none;" type="button" mat-raised-button (click)="getDay()" color="warn">Get TimeSheet</button>
          </form>
          
          <kendo-grid
            [data]="gridDataAll"
            [height]="300"
            [pageSize]="gridStateAll.take"
            [skip]="gridStateAll.skip"
            [pageable]="false"
            [sortable]="false"
            [size]="smallSize"
          >
            <kendo-grid-column field="firstName" title="First Name">
            </kendo-grid-column>
            <kendo-grid-column field="lastName" title="Last Name">
            </kendo-grid-column>
            <kendo-grid-column field="hoursWorked" title="Hours" [sortable]="false" [style]="{'text-align': 'right'}" format="###.##">
            </kendo-grid-column>
          </kendo-grid>
        </div>
        <br/>

        <span><strong>Time Sheet Employees by Day</strong></span>

        <kendo-grid
          [data]="gridDataAllEmployees"
          [height]="500"
          [pageSize]="gridStateAllEmployees.take"
          [skip]="gridStateAllEmployees.skip"
          [pageable]="false"
          [sortable]="false"
          [style.maxHeight.px]="390"
        [size]="smallSize"
        >
        <kendo-grid-column field="firstName" title="First Name">
        </kendo-grid-column>
        <kendo-grid-column field="lastName" title="Last Name">
        </kendo-grid-column>
        <kendo-grid-column field="dated" title="Date">
        </kendo-grid-column>
        <kendo-grid-column field="hoursWorked" title="Hours" [sortable]="false" [style]="{'text-align': 'right'}" format="###.##">
        </kendo-grid-column>
          
        </kendo-grid>

        <br/>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab title="Employees TimeSheet">
      <ng-template kendoTabContent>
        <div style="background-color: lightcyan;">
          <span><strong>TimeSheet Hours</strong></span>
          <br/>
          
          <kendo-grid
            id = "gridHours"
            [data]="gridDataHours"
            [height]="800"
            [pageSize]="gridStateHours.take"
            [skip]="gridStateHours.skip"
            [pageable]="false"
            [sortable]="false"
            [size]="smallSize"
            [rowClass]="rowCallback"
          >
            <kendo-grid-column field="dated" title="Dated">
            </kendo-grid-column>
            <kendo-grid-column field="dayOfWeek" title="Day">
            </kendo-grid-column>
            <kendo-grid-column field="hour09" title="09">
            </kendo-grid-column>
            <kendo-grid-column field="hour10" title="10">
            </kendo-grid-column>
            <kendo-grid-column field="hour11" title="11">
            </kendo-grid-column>
            <kendo-grid-column field="hour12" title="12">
            </kendo-grid-column>
            <kendo-grid-column field="hour13" title="13">
            </kendo-grid-column>
            <kendo-grid-column field="hour14" title="14">
            </kendo-grid-column>
            <kendo-grid-column field="hour15" title="15">
            </kendo-grid-column>
            <kendo-grid-column field="hour16" title="16">
            </kendo-grid-column>
            <kendo-grid-column field="hour17" title="17">
            </kendo-grid-column>
            <kendo-grid-column field="hour18" title="18">
            </kendo-grid-column>
            <kendo-grid-column field="hour19" title="19">
            </kendo-grid-column>
            <kendo-grid-column field="hour20" title="20">
            </kendo-grid-column>
            <kendo-grid-column field="hour21" title="21">
            </kendo-grid-column>
            <kendo-grid-column field="hour22" title="22">
            </kendo-grid-column>
            <kendo-grid-column field="hour23" title="23">
            </kendo-grid-column>
          </kendo-grid>
        </div>

        <br/>
      </ng-template>
    </kendo-tabstrip-tab>

  </kendo-tabstrip>

</div>
</div>
